import { Capacitor } from '@capacitor/core';
import 'cordova-plugin-android-permissions/www/permissions';

const isAndroidNative = () =>
  typeof Capacitor?.getPlatform === 'function' &&
  Capacitor.isNativePlatform() &&
  Capacitor.getPlatform() === 'android';

let cordovaPermissionsPromise;

function waitForCordovaPermissions() {
  if (cordovaPermissionsPromise) {
    return cordovaPermissionsPromise;
  }

  cordovaPermissionsPromise = new Promise((resolve) => {
    const resolveWithCurrent = () => resolve(window.cordova?.plugins?.permissions || null);

    if (window.cordova?.plugins?.permissions) {
      resolveWithCurrent();
      return;
    }

    const handler = () => {
      document.removeEventListener('deviceready', handler);
      resolveWithCurrent();
    };

    document.addEventListener('deviceready', handler, { once: true });
  });

  return cordovaPermissionsPromise;
}

function normalizePermissionsObject(perms) {
  if (!perms) {
    if (window.plugins?.permissions) {
      return window.plugins.permissions;
    }
    return null;
  }

  if (typeof perms.checkPermission === 'function') {
    return perms;
  }

  if (perms.androidPermissions) {
    return perms.androidPermissions;
  }

  return null;
}

export async function requestCameraPermission() {
  if (!isAndroidNative()) {
    return true;
  }

  const permissions = normalizePermissionsObject(await waitForCordovaPermissions());
  if (!permissions || !permissions.CAMERA) {
    console.error('[BlueWire] requestCameraPermission: plugin unavailable');
    return false;
  }

  return new Promise((resolve) => {
    permissions.checkPermission(
      permissions.CAMERA,
      (status) => {
        if (status?.hasPermission) {
          resolve(true);
          return;
        }

        permissions.requestPermissions(
          [permissions.CAMERA],
          (result) => resolve(!!result?.hasPermission),
          () => resolve(false)
        );
      },
      () => resolve(false)
    );
  });
}
